import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Share, Copy, Check } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import SocialShareButtons from './SocialShareButtons';
interface ShareDialogProps {
  title: string;
  image?: string;
  description?: string;
}
const ShareDialog: React.FC<ShareDialogProps> = ({
  title,
  image,
  description
}) => {
  const [copied, setCopied] = useState(false);
  const {
    toast
  } = useToast();
  const currentUrl = window.location.href;
  const shareProxyBase = 'https://hidccmqapkiyczyleerr.functions.supabase.co/share-article';
  const params = new URLSearchParams({ t: title, d: (description || `Share this article: ${title}`), u: currentUrl, s: 'Everhouse' });
  if (image) params.set('i', image);
  const shareUrl = `${shareProxyBase}?${params.toString()}`;
  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast({
        title: "Social preview link copied!",
        description: "Paste this link to show the correct image and description.",
      });

      // Reset copied state after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast({
        title: "Failed to copy",
        description: "Please try copying the link manually.",
        variant: "destructive"
      });
    }
  };
  return <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="text-muted-foreground hover:text-foreground">
          <Share size={14} className="mr-1" />
          Share
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-normal">Share this article</DialogTitle>
          <DialogDescription>
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center">
          <SocialShareButtons 
            url={currentUrl}
            title={title}
            description={description || `Share this article: ${title}`}
            image={image}
          />
        </div>
        <div className="flex items-center space-x-2">
          <div className="grid flex-1 gap-2">
            <div className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm text-muted-foreground overflow-hidden">
              {currentUrl}
            </div>
          </div>
          <Button size="sm" className="px-3" onClick={handleCopyLink}>
            {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          </Button>
        </div>
      </DialogContent>
    </Dialog>;
};
export default ShareDialog;